<route>
{
  "meta": {
    "permission": [
      "product.view_product"
    ]
  }
}
</route>

<template>
  <div>
    <dial-color v-model="dialog" :to-edit="toEdit" @done="reload = true" />
    <dial-clone-color v-model="cloneDialog" @done="reload = true" />
    <i-table
      :title="$t('apparel_colors')"
      :headers="headers"
      app="product.apparelcolor"
      api="product.apparelcolor"
      :reload.sync="reload"
      @click:create="open()"
      @click:edit="open($event)"
    >
      <template v-slot:extraToolbar>
        <i-btn
          v-if="canClone"
          color="info"
          icon="fa-clone"
          :title="$t('clone_colors')"
          @click="cloneDialog = true"
        />
      </template>
      <template v-slot:item.name="{ item }">
        {{
          $te(item.name.toLowerCase().replace(/\s+/g, '_'))
            ? $t(item.name.toLowerCase().replace(/\s+/g, '_'))
            : item.name
        }}
      </template>
      <template v-slot:item.image_path="{ item }">
        <div class="d-flex align-center justify-center my-2">
          <v-img
            v-if="item.image_path"
            :src="item.image_path"
            max-width="60"
            max-height="60"
            class="rounded"
          ></v-img>
        </div>
      </template>
    </i-table>
  </div>
</template>

<script>
import DialColor from '../../components/apparelColor/modal.vue'
import DialCloneColor from '../../components/apparelColor/cloneModal.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    DialColor,
    DialCloneColor
  },
  data() {
    return {
      reload: false,
      dialog: false,
      cloneDialog: false,
      toEdit: null
    }
  },
  computed: {
    ...mapGetters({
      storedCompany: 'company/getCompanyData',
      me: 'session/me'
    }),
    canClone() {
      const rawSuperuser = this.me && this.me.is_superuser
      const isConfirmedCompanyUser =
        rawSuperuser === false ||
        rawSuperuser === 0 ||
        ['false', '0'].includes(String(rawSuperuser).toLowerCase())

      return !!this.storedCompany && isConfirmedCompanyUser
    },
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name',
          align: 'left'
        },
        {
          text: this.$t('image'),
          value: 'image_path',
          align: 'center'
        },
        {
          text: this.$t('action'),
          value: 'actions'
        }
      ]
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    }
  }
}
</script>
